module.exports = __webpack_public_path__ + "img/foot_qq.94c01f71.png";